import { Component } from '@angular/core';

import {GlobalAdCounter} from '../../providers/global-ad-counter';

const url = 'https://cdn.chitika.net/getads.js';

@Component({
    selector: 'ad-footer',
  templateUrl: 'ad-footer.html'
})
export class AdFooter {

  loadAPI: Promise<any>;

  public placement_id:number;
  public bannerId:string = "not set";
  public addCounter:number = 0;

  //constructor(public globalAdCounter:GlobalAdCounter) {
  //  this.globalAdCounter.addCount += 1;
  //  this.placement_id = this.globalAdCounter.addCount;
  //}
  constructor() {
  }

  chitikaAddHeight(){
    window['CHITIKA'] = undefined;
    
    if (window['CHITIKA'] === undefined){
         window['CHITIKA'] = { 'units' : [] };
         };
        var unit = {"calltype":"async[2]","publisher":"picladder","width":320,"height":50,"sid":"Chitika Default"};
        //this.placement_id = window['CHITIKA'].units.length;
        //this.placement_id = window['CHITIKA'].units.length;
        /*if(this.placement_id){
            this.placement_id = this.placement_id +1;
        }
        else{
            this.placement_id = 0;
        }
        */
         window['CHITIKA'].units.push(unit);
        this.bannerId = "chitikaAdBlock-"+this.placement_id.toString();
        //document.write('<div id="chitikaAdBlock-' + this.placement_id + '"></div>');
  }

  //ngOnInit(){
    ngAfterViewInit(){
    window['CHITIKA'] = undefined;
    this.loadAPI = new Promise((resolve) => {
        console.log('resolving promise...');
        //if(this.bannerId == "not set"){
            this.loadScript();
        //}
    });
}

ngOnDestroy(){
    alert('destroy');
}

public loadScript() {
    //let test = document.getElementsByTagName('head')[0]
    console.log('preparing to load...')
    let node = document.createElement('script');
    node.src = url;
    node.type = 'text/javascript';
    node.async = true;
    node.charset = 'utf-8';
    document.getElementsByTagName('head')[0].appendChild(node);
    this.chitikaAddHeight();
}
  
}



// WEBPACK FOOTER //
// ./src/pages/ad-footer/ad-footer.ts